import { render, staticRenderFns } from "./MonthlyData.vue?vue&type=template&id=348bcd73&scoped=true&"
import script from "./MonthlyData.vue?vue&type=script&lang=js&"
export * from "./MonthlyData.vue?vue&type=script&lang=js&"
import style0 from "./MonthlyData.vue?vue&type=style&index=0&id=348bcd73&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "348bcd73",
  null
  
)

export default component.exports